const signupBlocks = document.querySelectorAll('.block-newsletter-signup');

// Match on value since the signup form's email field may be a plain text input.
const getEmail = (form) =>
	Array.from(new FormData(form).values()).find(
		(value) => typeof value === 'string' && value.includes('@')
	);

signupBlocks.forEach((signupBlock) => {
	const signupForm = signupBlock.querySelector(
		'.block-newsletter-signup__form form'
	);
	const secondary = signupBlock.querySelector(
		'.block-newsletter-signup__secondary'
	);

	if (!signupForm || !secondary) {
		return;
	}

	const signupFormId = signupForm.id.replace('gform_', 'gform-');
	let submittedEmail = '';

	// Gravity Forms submits from the button's click handler, so no submit event fires.
	signupBlock.addEventListener(
		'click',
		(event) => {
			const submitButton = event.target.closest(
				'.block-newsletter-signup__form [type="submit"]'
			);

			if (submitButton?.form) {
				submittedEmail = getEmail(submitButton.form) ?? '';
			}
		},
		true
	);

	window.addEventListener('form-submit-success', (event) => {
		if (!submittedEmail || event.detail?.formId !== signupFormId) {
			return;
		}

		const emailInput = secondary.querySelector(
			'.gfield--type-hidden input'
		);

		if (emailInput) {
			emailInput.value = submittedEmail;
		}

		secondary.hidden = false;
		submittedEmail = '';
	});
});
